import React from "react";
import "./Footer.css";
import logo from "../Assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo + Copyright */}
        <div className="footer-section footer-logo-section">
          <img src={logo} alt="OnenessWeb Logo" className="footer-logo" />
          <p className="footer-copy">© Copyright 2026 Onenessweb</p>
          <p className="footer-cin">CIN: U62099GJ2025OPC167330</p>
        </div>

        {/* Useful Links */}
        <div className="footer-section footer-links">
          <h3 className="footer-title">Useful Links</h3>
          <ul className="footer-list">
            <li className="footer-list-item">
              <a className="footer-link" href="/">
                Home
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/portfolio">
                Work
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/about">
                About us
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/services">
                Services
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="blog">
                Blog
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/contact">
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section footer-services">
          <h3 className="footer-title">Services</h3>
          <ul className="footer-list">
            <li className="footer-list-item">
              <a className="footer-link" href="/webdev">
                Web Development
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/appdev">
                App Development
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/digi-marketing">
                Digital Marketing
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/e-commerce">
                E-Commerce
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/uiux">
                UI/UX Design
              </a>
            </li>
            <li className="footer-list-item">
              <a className="footer-link" href="/quality-analyst">
                Quality Analyst
              </a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section footer-contact">
          <h3 className="footer-title">Contact Us</h3>
          <a href="tel:+919978611325" className="footer-contact-line">
            <p>📞 +91-9978611325</p>
          </a>
          <a
            href="mailto:sales@onenesswebs.com"
            className="footer-contact-line"
          >
            <p>📧 sales@onenesswebs.com</p>
          </a>
          <p className="footer-contact-line">
            📍 Bilimora - 396321, Gujarat, India.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
